import dynamic from "next/dynamic";
import { ThemeProvider } from "lib/contexts/themeContext";

const components = {
  ButtonCTA: dynamic(() => import("./ButtonCTA")),
  Image: dynamic(() => import("next/image")),
  Link: dynamic(() => import("next/link")),
  ButtonApply: dynamic(() =>
    import("./ButtonCTA").then((comp) => comp.ButtonApply),
  ),
  ButtonTest: dynamic(() =>
    import("./ButtonCTA").then((comp) => comp.ButtonTest),
  ),
  ButtonAssist: dynamic(() =>
    import("./ButtonCTA").then((comp) => comp.ButtonAssist),
  ),
  ButtonCommunity: dynamic(() =>
    import("./ButtonCTA").then((comp) => comp.ButtonCommunity),
  ),
  ButtonForm: dynamic(() =>
    import("./ButtonCTA").then((comp) => comp.ButtonForm),
  ),
  ButtonLawyer: dynamic(() =>
    import("./ButtonCTA").then((comp) => comp.ButtonLawyer),
  ),
  ButtonTracker: dynamic(() =>
    import("./ButtonCTA").then((comp) => comp.ButtonTracker),
  ),
};

const provider = {
  component: ThemeProvider,
  props: {},
};

export default {
  components,
  provider,
};
